import React, { useState, useEffect } from "react";
import "./result_card.css";
import { Link, useHistory } from "react-router-dom";
import Rating from "../logo/Rating.svg";
import Bookmark from "../logo/BookmarkSmall.svg";
import Bookmarked from "../logo/Bookmarked.svg";
import { useSelector } from "react-redux";
import Cart from "../logo/Cart.svg";
import { post } from "../common/api";
import { useAlert } from "react-alert";
import { stringToBoolean } from "../common/utils";
import axios from "axios";

export function ResultCard({
  id,
  name,
  image_url,
  category = [],
  rating,
  min_spending,
  max_spending,
}) {
  let [isBookmarked, setIsBookmarked] = useState(false);
  let [isLoading, setIsLoading] = useState(false);
  const auth = useSelector((state) => state.auth);
  const alert = useAlert();

  const history = useHistory();
  const poi_id = id;

  var min = new Intl.NumberFormat("ID").format(min_spending);
  var max = new Intl.NumberFormat("ID").format(max_spending);

  useEffect(() => {
    const source = axios.CancelToken.source();
    const checkPOI = async () => {
      try {
        setIsLoading(true);
        const res = await post(
          "/api/bucket-list/check",
          { poi_id },
          {
            headers: {
              Authorization: `Token ${auth.token}`,
            },
            cancelToken: source.token,
          }
        );
        const { message } = res.data;
        setIsBookmarked(stringToBoolean(message));
      } catch (e) {
        console.error(e);
      }
      setIsLoading(false);
    };
    if (auth.token) {
      checkPOI();
    }
    return () => {
      source.cancel();
    };
  }, [auth, poi_id]);

  const togglePOI = async (action) => {
    try {
      setIsLoading(true);
      const res = await post(
        `/api/bucket-list/${action}`,
        { poi_id },
        {
          headers: {
            Authorization: `Token ${auth.token}`,
          },
        }
      );
      const { message } = res.data;
      alert.success(message, { timeout: 1000 });
      setIsBookmarked(!isBookmarked);
    } catch (e) {
      const message =
        e.response?.data?.message || "Something went wrong. Please try again";
      alert.error(message);
      console.error(e);
    }
    setIsLoading(false);
  };

  const handleClick = (event) => {
    if (auth.isAuthenticated) {
      if (!isBookmarked) {
        togglePOI("add");
      } else {
        togglePOI("remove");
      }
    } else {
      history.push("/login");
    }
  };

  return (
    <div className="result-card">
      <div className="image-div">
        <Link className="result-link" to={`/poi/${id}`}>
          <img src={image_url} alt="poi" className="image-div"></img>
        </Link>
        <button
          data-testid="bookmark-action-button"
          onClick={handleClick}
          disabled={isLoading}
        >
          {isLoading && (
            <div className="bookmark-div">
              <div className="spinner-border" role="status" />
            </div>
          )}
          {!isLoading && isBookmarked && (
            <img
              src={Bookmarked}
              alt="bookmarked-logo"
              className="bookmark-div"
            />
          )}
          {!isLoading && !isBookmarked && (
            <img
              src={Bookmark}
              alt="not-bookmark-logo"
              className="bookmark-div"
            />
          )}
        </button>
        {!(category.category === undefined) && (
          <button>
            <img src={Cart} alt="cart-logo" className="cart-div"></img>
          </button>
        )}
      </div>
      <Link className="result-link" to={`/poi/${id}`}>
        <div className="description">
          <h4 data-testid="poi-name" className="">
            {name}
          </h4>
          <div className="d-flex flex-row">
            <div className="category d-inline-flex">
              <h5 data-testid="poi-category" className="category-title">
                {category.category === undefined ? category : category.category}
              </h5>
            </div>
          </div>
          <img
            className="rating"
            src={Rating}
            placeholder="rating-star"
            alt="rating"
          ></img>
          <h6>
            Rp {min} {max !== min && <span>&nbsp;-&nbsp;Rp {max}</span>}
          </h6>
        </div>
      </Link>
    </div>
  );
}

export default ResultCard;
